<div class="appbased-tv__lang">
  <button ds-button
          [tabIndex]="0"
          [a11yDescription]="'global.language.alt' | translate"
          [variant]="variant"
          (click)="toggleLang()">
    <span class="text-semi text-uppercase" [attr.aria-hidden]="true">{{langLabel}}</span>
  </button>
</div>